import { useState, useEffect, useRef } from "react";
import { Facebook, Instagram, MapPin, Menu, X, ArrowUpRight, ChevronDown } from "lucide-react";
import nosotros from '../../../images/Nosotros/nosotros.jpg'

const sucursales = [
    { nombre: "Melo" },
    { nombre: "Integral Sur" },
    { nombre: "Serrano" },
    { nombre: "Laboulaye" },
    { nombre: "Pueblo Italiano" },
    { nombre: "Buchardo" },
    { nombre: "Villa Valeria" },
];




const stats = [
    { n: "40+", label: "Años de trayectoria" },
    { n: "7", label: "Sucursales activas" },
    { n: "5000+", label: "Productores activos" },
    { n: "365", label: "Días de servicio" },
];

function useInView(threshold = 0.15) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold });
        if (ref.current) obs.observe(ref.current);
        return () => obs.disconnect();
    }, []);
    return [ref, inView];
}

function AnimatedSection({ children, className = "", delay = 0 }) {
    const [ref, inView] = useInView();
    return (
        <div ref={ref} className={className} style={{
            opacity: inView ? 1 : 0,
            transform: inView ? 'translateY(0)' : 'translateY(40px)',
            transition: `opacity 0.8s ease ${delay}s, transform 0.8s ease ${delay}s`
        }}>
            {children}
        </div>
    );
}

export default function Landing() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [activeService, setActiveService] = useState(0);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleMouse = (e) => setMousePos({ x: e.clientX, y: e.clientY });
        window.addEventListener("mousemove", handleMouse);
        return () => window.removeEventListener("mousemove", handleMouse);
    }, []);

    return (
        <div className="min-h-screen font-sans bg-[#050f08] text-white overflow-x-hidden">

            {/* CURSOR GLOW */}
            <div
                className="fixed pointer-events-none z-[9999] w-96 h-96 rounded-full"
                style={{
                    left: mousePos.x - 192,
                    top: mousePos.y - 192,
                    background: 'radial-gradient(circle, rgba(201,168,76,0.06) 0%, transparent 70%)',
                    transition: 'left 0.3s ease, top 0.3s ease',
                }}
            />

            {/* NAVBAR */}


            <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${scrolled
                ? "bg-[#050f08]/95 backdrop-blur-2xl border-b border-white/5"
                : "bg-transparent"
                }`}>
                <div className="max-w-7xl mx-auto px-6 md:px-12">

                    {/* BARRA SUPERIOR — solo visible cuando no scrolleó */}
                    <div className={`flex justify-end items-center gap-6 py-2 border-b border-white/5 transition-all duration-500 ${scrolled ? "h-0 overflow-hidden opacity-0 py-0 border-0" : "opacity-100"}`}>
                        <a href="https://www.facebook.com/integralagrop/?locale=es_LA" target="_blank" className="text-white/20 hover:text-[#c9a84c] transition-colors no-underline">
                            <Facebook size={12} strokeWidth={1.5} />
                        </a>
                        <a href="https://www.instagram.com/integralagropecuaria/" target="_blank" className="text-white/20 hover:text-[#c9a84c] transition-colors no-underline">
                            <Instagram size={12} strokeWidth={1.5} />
                        </a>
                        <div className="w-px h-3 bg-white/10" />
                        <span className="text-white/20 text-[9px] uppercase tracking-[0.4em] font-bold">Sur de Córdoba, Argentina</span>
                    </div>

                    {/* BARRA PRINCIPAL */}
                    <div className="flex justify-between items-center py-4">

                        {/* LOGO */}
                        <div className="flex items-center gap-4 group cursor-pointer">
                            <div className="relative w-10 h-10 rounded-xl border border-white/10 flex items-center justify-center overflow-hidden group-hover:border-[#c9a84c]/40 transition-all duration-500">
                                <img src="logo-integ.png" alt="Logo" className="w-7 h-7 object-contain" />
                                <div className="absolute inset-0 bg-[#c9a84c]/0 group-hover:bg-[#c9a84c]/5 transition-all duration-500" />
                            </div>
                            <div>
                                <div className="text-white text-[13px] font-black tracking-widest uppercase leading-none">Integral Agropecuaria S.R.L</div>
                                <div className="text-[#c9a84c]/50 text-[8px] font-bold tracking-[0.5em] uppercase mt-1">Conocernos rinde</div>
                            </div>
                        </div>

                        {/* LINKS DESKTOP */}
                        <ul className="hidden lg:flex gap-10 list-none m-0 p-0">
                            {["Nosotros", "Servicios", "Sucursales", "Productos"].map((item) => (
                                <li key={item}>
                                    <a href={`#${item.toLowerCase()}`} className="relative text-white/40 hover:text-white text-[10px] font-black uppercase tracking-[0.3em] transition-all duration-300 no-underline group py-2 block">
                                        {item}
                                        <span className="absolute bottom-0 left-0 w-0 h-px bg-[#c9a84c] transition-all duration-500 group-hover:w-full" />
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {/* ÁREA CLIENTES + MOBILE BTN */}
                        <div className="flex items-center gap-4">
                            <a href="/login" className="hidden md:flex items-center gap-3 group no-underline relative overflow-hidden bg-white/[0.03] hover:bg-[#c9a84c]/10 border border-white/10 hover:border-[#c9a84c]/40 px-5 py-2.5 rounded-xl transition-all duration-500">
                                {/* Punto pulsante */}
                                <span className="relative flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#c9a84c] opacity-50" />
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-[#c9a84c]" />
                                </span>
                                <span className="text-white/60 group-hover:text-white text-[10px] font-black uppercase tracking-widest transition-colors duration-300">Área Clientes</span>
                                <ArrowUpRight size={11} className="text-[#c9a84c] opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                            </a>

                            <button className="lg:hidden text-white/50 hover:text-white transition-colors p-1" onClick={() => setMenuOpen(!menuOpen)}>
                                {menuOpen ? <X size={22} /> : <Menu size={22} />}
                            </button>
                        </div>
                    </div>
                </div>

                {/* MOBILE MENU */}
                <div className={`fixed inset-x-0 top-0 lg:hidden transition-all duration-500 z-[-1] ${menuOpen ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}`}>
                    <div className="bg-[#050f08] border-b border-white/10 px-8 pt-28 pb-10 flex flex-col gap-7">
                        {["Nosotros", "Servicios", "Sucursales", "Productos"].map((item, i) => (
                            <a key={item} href={`#${item.toLowerCase()}`} onClick={() => setMenuOpen(false)}
                                className="text-white/60 hover:text-white text-sm font-bold uppercase tracking-[0.4em] no-underline transition-all flex justify-between items-center border-b border-white/5 pb-7"
                                style={{ transitionDelay: `${i * 0.05}s` }}>
                                {item}
                                <ArrowUpRight size={14} className="text-[#c9a84c]" />
                            </a>
                        ))}
                        <a href="/login" onClick={() => setMenuOpen(false)}
                            className="mt-2 flex items-center justify-center gap-3 bg-[#c9a84c] text-[#050f08] py-4 rounded-xl font-black uppercase tracking-[0.2em] text-[13px] no-underline">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#050f08]/40" />
                            Área Clientes
                        </a>
                    </div>
                    <div className="h-screen bg-black/60 backdrop-blur-sm" onClick={() => setMenuOpen(false)} />
                </div>
            </nav>

            {/* HERO */}
            <section className="relative min-h-screen flex flex-col justify-center px-6 md:px-16 overflow-hidden">
                {/* BG IMAGE */}
                <div className="absolute inset-0">
                    <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=90"
                        alt="" className="w-full h-full object-cover opacity-15" />
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, #050f08 0%, transparent 30%, transparent 60%, #050f08 100%)' }} />
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, #050f08 0%, transparent 60%)' }} />
                </div>

                {/* GRAIN OVERLAY */}
                <div className="absolute inset-0 opacity-[0.03]" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
                }} />

                <div className="relative z-10 max-w-5xl pt-32 pb-24">
                    <AnimatedSection delay={0}>
                        <div className="inline-flex items-center gap-3 mb-10 px-5 py-2 border border-[#c9a84c]/20 rounded-full bg-[#c9a84c]/5">
                            <div className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] animate-pulse" />
                            <span className="text-[#c9a84c] text-[9px] font-black tracking-[0.6em] uppercase">Acompañando al productor desde hace 40 años</span>
                        </div>
                    </AnimatedSection>

                    <AnimatedSection delay={0.1}>
                        <h1 className="text-[clamp(3rem,10vw,7rem)] font-black text-white tracking-tighter leading-[0.85] mb-8">
                            SOMOS<br />
                            CAMPO.<br />
                            <span style={{ WebkitTextStroke: '1px #c9a84c', color: 'transparent' }}>SOMOS</span>{" "}
                            <span className="text-[#c9a84c]">INTEGRAL.</span>
                        </h1>
                    </AnimatedSection>

                    <AnimatedSection delay={0.2}>
                        <p className="text-white/40 text-lg md:text-xl max-w-xl mb-12 font-light leading-relaxed">
                            Brindamos soluciones eficientes los 365 días del año. Nuestra trayectoria es el respaldo que su producción necesita.
                        </p>
                    </AnimatedSection>

                    <AnimatedSection delay={0.3}>
                        <div className="flex flex-wrap gap-4">
                            <a href="#servicios" className="group flex items-center gap-3 bg-[#c9a84c] hover:bg-[#ddb94e] text-[#050f08] font-black uppercase tracking-widest text-[11px] px-8 py-4 rounded-full transition-all duration-300 no-underline">
                                Ver servicios
                                <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </a>
                            <a href="/login" className="flex items-center gap-3 border border-white/15 hover:border-white/40 text-white/70 hover:text-white font-black uppercase tracking-widest text-[11px] px-8 py-4 rounded-full transition-all duration-300 no-underline">
                                Área clientes
                            </a>
                        </div>
                    </AnimatedSection>
                </div>

                {/* STATS */}
                <div className="relative z-10 max-w-5xl grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 rounded-2xl overflow-hidden mb-12">
                    {stats.map((s, i) => (
                        <AnimatedSection key={s.label} delay={0.4 + i * 0.08} className="bg-white/[0.02] hover:bg-white/[0.05] transition-all px-8 py-8">
                            <div className="text-3xl md:text-4xl font-black text-[#c9a84c] mb-1">{s.n}</div>
                            <div className="text-white/30 text-[10px] uppercase tracking-widest font-bold">{s.label}</div>
                        </AnimatedSection>
                    ))}
                </div>

                {/* SCROLL INDICATOR */}
                <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
                    <ChevronDown size={16} className="text-white/20" />
                </div>
            </section>

            {/* NOSOTROS */}
            {/* NOSOTROS */}
            <section id="nosotros" className="py-24 px-6 md:px-16 bg-[#050f08] overflow-hidden">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-14 items-center">

                    {/* IZQUIERDA */}
                    <AnimatedSection>
                        <div className="text-[#c9a84c] text-[10px] font-black uppercase tracking-[0.6em] mb-6">Quiénes somos</div>
                        <h2 className="text-4xl md:text-5xl font-black tracking-tighter leading-tight mb-6">
                            Cuatro décadas<br />
                            <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.3)', color: 'transparent' }}>construyendo</span><br />
                            el campo.
                        </h2>
                        <p className="text-white/40 leading-relaxed text-sm mb-10">
                            Integral Agropecuaria S.R.L. nació con el objetivo de brindar al productor agropecuario un servicio completo. Presencia en 7 localidades del sur de Córdoba, con equipos capacitados y las mejores marcas del mercado.
                        </p>

                        {/* VALORES */}
                        <div className="flex flex-col gap-3">
                            {[
                                { t: 'Sustentabilidad', d: 'Prácticas responsables con el medioambiente' },
                                { t: 'Cercanía', d: 'Relación directa con cada productor' },
                                { t: 'Confianza', d: '40 años de transparencia en cada operación' },
                            ].map((v) => (
                                <div key={v.t} className="flex items-start gap-4 group">
                                    <div className="w-1 h-1 rounded-full bg-[#c9a84c]/40 mt-2 flex-shrink-0 group-hover:bg-[#c9a84c] transition-colors" />
                                    <div>
                                        <span className="text-white/60 text-xs font-black uppercase tracking-wider">{v.t}</span>
                                        <span className="text-white/20 text-xs ml-2">— {v.d}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </AnimatedSection>

                    {/* DERECHA — imagen con animación */}
                    <AnimatedSection delay={0.2}>
                        <div className="relative group">

                            {/* MARCO DECORATIVO ANIMADO */}
                            <div className="absolute -inset-3 rounded-3xl border border-[#c9a84c]/10 group-hover:border-[#c9a84c]/25 transition-all duration-700" />
                            <div className="absolute -inset-6 rounded-3xl border border-white/[0.03] group-hover:border-white/[0.06] transition-all duration-1000" />

                            {/* IMAGEN CON CLIP REVEAL */}
                            <div
                                className="relative rounded-2xl overflow-hidden border border-white/8"
                                style={{
                                    boxShadow: '0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.04)'
                                }}>

                                {/* OVERLAY REVEAL que desaparece */}
                                <div
                                    className="absolute inset-0 bg-[#050f08] z-10 pointer-events-none"
                                    style={{
                                        animation: 'revealSlide 1.2s cubic-bezier(0.77,0,0.175,1) 0.5s forwards',
                                    }}
                                />

                                <img
                                    src={nosotros}
                                    alt="Equipo Integral Agropecuaria"
                                    className="w-full h-[500px] object-cover transition-transform duration-[2s] group-hover:scale-[1.03]"
                                    style={{ objectPosition: 'center 25%' }}
                                />

                                {/* GRADIENTE INFERIOR */}
                                <div className="absolute inset-0 bg-gradient-to-t from-[#050f08]/50 via-transparent to-transparent" />

                            
                            </div>

                        </div>
                    </AnimatedSection>
                </div>

                {/* KEYFRAMES */}
                <style>{`
        @keyframes revealSlide {
            0%   { transform: scaleX(1); transform-origin: left; }
            100% { transform: scaleX(0); transform-origin: left; }
        }
        @keyframes fadeUpBadge {
            0%   { opacity: 0; transform: translateY(12px); }
            100% { opacity: 1; transform: translateY(0); }
        }
    `}</style>
            </section>
            {/* SERVICIOS */}
            {/* SERVICIOS */}
            <section id="servicios" className="py-32 px-6 md:px-16 bg-[#030a04]">
                <div className="max-w-7xl mx-auto">
                    <AnimatedSection className="mb-20 flex flex-col md:flex-row justify-between items-end gap-8">
                        <div>
                            <div className="text-[#c9a84c] text-[10px] font-black uppercase tracking-[0.6em] mb-4">Operaciones</div>
                            <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-none">
                                Soluciones<br />
                                <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.2)', color: 'transparent' }}>para cada</span><br />
                                etapa.
                            </h2>
                        </div>
                        <p className="text-white/30 text-sm max-w-xs leading-relaxed">
                            Brindamos servicios integrales al productor del sur de Córdoba, combinando experiencia, tecnología y compromiso.
                        </p>
                    </AnimatedSection>

                    {/* SERVICIOS PRINCIPALES — grid grande */}
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                        {[
                            {
                                numero: '01',
                                titulo: 'Fumigación Aérea',
                                desc: 'Cobertura rápida y precisa con aviones aplicadores de última generación. Ideal para grandes superficies con acceso difícil.',
                                tag: 'Servicio propio',
                                grande: true,
                            },
                            {
                                numero: '02',
                                titulo: 'Fumigación Terrestre',
                                desc: 'Aplicación terrestre con equipos modernos para mayor precisión en lotes medianos y chicos.',
                                tag: 'Servicio propio',
                                grande: false,
                            },
                            {
                                numero: '03',
                                titulo: 'Asesoramiento Técnico',
                                desc: 'Ingenieros agrónomos en campo. Diagnóstico, planificación y seguimiento de cada lote durante toda la campaña.',
                                tag: 'Incluido',
                                grande: false,
                            },
                        ].map((s, i) => (
                            <AnimatedSection key={s.titulo} delay={i * 0.1}>
                                <div className={`group relative border border-white/5 rounded-2xl p-8 hover:border-[#c9a84c]/20 transition-all duration-500 overflow-hidden h-full ${s.grande ? 'lg:col-span-1' : ''}`}>
                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700"
                                        style={{ background: 'radial-gradient(circle at 0% 100%, rgba(201,168,76,0.05) 0%, transparent 60%)' }} />
                                    <div className="flex items-start justify-between mb-6">
                                        <span className="text-[#c9a84c]/20 text-4xl font-black">{s.numero}</span>
                                        <span className="text-[9px] text-[#c9a84c]/50 font-black uppercase tracking-widest border border-[#c9a84c]/15 px-3 py-1 rounded-full">
                                            {s.tag}
                                        </span>
                                    </div>
                                    <div className="w-8 h-px bg-[#c9a84c]/20 mb-5 group-hover:w-16 transition-all duration-500" />
                                    <h3 className="text-white font-black text-lg uppercase tracking-wide mb-3 group-hover:text-[#c9a84c] transition-colors duration-300">
                                        {s.titulo}
                                    </h3>
                                    <p className="text-white/25 text-xs leading-relaxed">{s.desc}</p>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>

                    {/* SERVICIOS SECUNDARIOS — grid horizontal */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {[
                            {
                                numero: '04',
                                titulo: 'Semillas',
                                desc: 'Maíz, soja, trigo y forrajeras. Variedades certificadas seleccionadas para el sur de Córdoba.',
                            },
                            {
                                numero: '05',
                                titulo: 'Fertilizantes & Agroquímicos',
                                desc: 'Líneas líderes del mercado. Herbicidas, insecticidas, fungicidas y fertilizantes de base.',
                            },
                            {
                                numero: '06',
                                titulo: 'Silobolsas & Acopio',
                                desc: 'Soluciones de almacenaje en campo para preservar la calidad de la cosecha.',
                            },
                            {
                                numero: '07',
                                titulo: 'Transporte de Cereales',
                                desc: 'Flota propia para el traslado de granos desde el campo hasta destino final.',
                            },
                        ].map((s, i) => (
                            <AnimatedSection key={s.titulo} delay={0.3 + i * 0.08}>
                                <div className="group relative border border-white/5 rounded-2xl p-6 hover:border-[#c9a84c]/20 transition-all duration-500 h-full overflow-hidden">
                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700"
                                        style={{ background: 'radial-gradient(circle at 50% 0%, rgba(201,168,76,0.04) 0%, transparent 70%)' }} />
                                    <span className="text-[#c9a84c]/15 text-2xl font-black block mb-4">{s.numero}</span>
                                    <h4 className="text-white/80 font-black text-[12px] uppercase tracking-wider mb-3 group-hover:text-[#c9a84c] transition-colors duration-300">
                                        {s.titulo}
                                    </h4>
                                    <p className="text-white/20 text-[11px] leading-relaxed">{s.desc}</p>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>


                </div>
            </section>

            {/* PRODUCTOS */}
            {/* PRODUCTOS */}
            <section id="productos" className="py-32 px-6 md:px-16 bg-[#050f08]">
                <div className="max-w-7xl mx-auto">

                    <AnimatedSection className="mb-20 flex flex-col md:flex-row justify-between items-end gap-8">
                        <div>
                            <div className="text-[#c9a84c] text-[10px] font-black uppercase tracking-[0.6em] mb-4">Portafolio</div>
                            <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-none">
                                Todo lo que<br />
                                <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.2)', color: 'transparent' }}>el campo</span><br />
                                <span className="text-[#c9a84c]">necesita.</span>
                            </h2>
                        </div>
                        <p className="text-white/30 text-sm max-w-xs leading-relaxed">
                            Trabajamos con las mejores marcas del mercado. Desde insumos básicos hasta soluciones técnicas de última generación para cada etapa productiva.
                        </p>
                    </AnimatedSection>

                    {/* CATEGORÍAS PRINCIPALES */}
                    <div className="grid md:grid-cols-2 gap-4 mb-4">

                        {/* SEMILLAS — card grande */}
                        <AnimatedSection delay={0}>
                            <div className="group relative border border-white/5 rounded-2xl p-10 hover:border-[#c9a84c]/20 transition-all duration-500 overflow-hidden h-full">
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700"
                                    style={{ background: 'radial-gradient(circle at 0% 0%, rgba(201,168,76,0.06) 0%, transparent 60%)' }} />
                                <div className="flex items-start justify-between mb-8">
                                    <span className="text-[9px] text-[#c9a84c]/50 font-black uppercase tracking-widest border border-[#c9a84c]/15 px-3 py-1 rounded-full">
                                        Categoría principal
                                    </span>
                                    <span className="text-[#c9a84c]/10 text-5xl font-black">01</span>
                                </div>
                                <h3 className="text-white font-black text-2xl uppercase tracking-tight mb-4 group-hover:text-[#c9a84c] transition-colors duration-300">
                                    Semillas
                                </h3>
                                <p className="text-white/30 text-sm leading-relaxed mb-8">
                                    Variedades certificadas seleccionadas para el clima y suelo del sur de Córdoba. Maíz temprano y tardío, soja, trigo, girasol, sorgo y forrajeras.
                                </p>
                                <div className="grid grid-cols-3 gap-3">
                                    {['Maíz', 'Soja', 'Trigo', 'Girasol', 'Sorgo', 'Forrajeras'].map(item => (
                                        <div key={item} className="border border-white/5 rounded-lg px-3 py-2 text-center group-hover:border-[#c9a84c]/10 transition-all">
                                            <span className="text-white/40 text-[10px] font-black uppercase tracking-wider">{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimatedSection>

                        {/* FITOSANITARIOS — card grande */}
                        <AnimatedSection delay={0.1}>
                            <div className="group relative border border-white/5 rounded-2xl p-10 hover:border-[#c9a84c]/20 transition-all duration-500 overflow-hidden h-full">
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700"
                                    style={{ background: 'radial-gradient(circle at 100% 0%, rgba(201,168,76,0.06) 0%, transparent 60%)' }} />
                                <div className="flex items-start justify-between mb-8">
                                    <span className="text-[9px] text-[#c9a84c]/50 font-black uppercase tracking-widest border border-[#c9a84c]/15 px-3 py-1 rounded-full">
                                        Categoría principal
                                    </span>
                                    <span className="text-[#c9a84c]/10 text-5xl font-black">02</span>
                                </div>
                                <h3 className="text-white font-black text-2xl uppercase tracking-tight mb-4 group-hover:text-[#c9a84c] transition-colors duration-300">
                                    Fitosanitarios
                                </h3>
                                <p className="text-white/30 text-sm leading-relaxed mb-8">
                                    Líneas líderes del mercado para protección total del cultivo. Herbicidas, insecticidas y fungicidas con respaldo técnico en cada aplicación.
                                </p>
                                <div className="grid grid-cols-3 gap-3">
                                    {['Herbicidas', 'Insecticidas', 'Fungicidas', 'Acaricidas', 'Coadyuvantes', 'Curasemillas'].map(item => (
                                        <div key={item} className="border border-white/5 rounded-lg px-3 py-2 text-center group-hover:border-[#c9a84c]/10 transition-all">
                                            <span className="text-white/40 text-[10px] font-black uppercase tracking-wider">{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimatedSection>
                    </div>

                    {/* CATEGORÍAS SECUNDARIAS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        {[
                            {
                                n: '03',
                                titulo: 'Fertilizantes',
                                desc: 'Nutrición balanceada para cada cultivo y etapa. Urea, fosfatos, azufre, micronutrientes y fertilizantes foliares.',
                                items: ['Urea', 'MAP / DAP', 'Superfosfato', 'Azufre', 'Foliares'],
                            },
                            {
                                n: '04',
                                titulo: 'Silobolsas & Almacenaje',
                                desc: 'Soluciones de almacenaje en campo para preservar la calidad de la cosecha. Silobolsas, tubos y accesorios.',
                                items: ['Silobolsas', 'Tubos', 'Accesorios', 'Extractoras'],
                            },
                            {
                                n: '05',
                                titulo: 'Pasturas & Ganadería',
                                desc: 'Variedades forrajeras para maximizar la conversión y el rinde ganadero. Semillas, mezclas y verdeos.',
                                items: ['Alfalfa', 'Festuca', 'Trébol', 'Verdeos'],
                            },
                        ].map((p, i) => (
                            <AnimatedSection key={p.titulo} delay={0.2 + i * 0.08}>
                                <div className="group relative border border-white/5 rounded-2xl p-8 hover:border-[#c9a84c]/20 transition-all duration-500 overflow-hidden h-full">
                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700"
                                        style={{ background: 'radial-gradient(circle at 50% 100%, rgba(201,168,76,0.04) 0%, transparent 70%)' }} />
                                    <div className="flex items-start justify-between mb-6">
                                        <span className="text-[#c9a84c]/10 text-3xl font-black">{p.n}</span>
                                    </div>
                                    <div className="w-6 h-px bg-[#c9a84c]/20 mb-4 group-hover:w-full transition-all duration-700" />
                                    <h3 className="text-white font-black text-base uppercase tracking-wide mb-3 group-hover:text-[#c9a84c] transition-colors duration-300">
                                        {p.titulo}
                                    </h3>
                                    <p className="text-white/25 text-xs leading-relaxed mb-5">{p.desc}</p>
                                    <div className="flex flex-wrap gap-2">
                                        {p.items.map(item => (
                                            <span key={item} className="text-[9px] text-white/30 font-black uppercase tracking-wider border border-white/5 px-2 py-1 rounded-md group-hover:border-[#c9a84c]/10 transition-all">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>


                </div>
            </section>

            {/* SUCURSALES */}
            <section id="sucursales" className="py-32 px-6 md:px-16 bg-[#030a04] border-y border-white/5">
                <div className="max-w-7xl mx-auto">
                    <AnimatedSection className="mb-24 flex flex-col md:flex-row justify-between items-end gap-10">
                        <div>
                            <div className="text-[#c9a84c] text-[10px] font-black uppercase tracking-[0.6em] mb-6">Red de servicios</div>
                            <h2 className="text-5xl md:text-7xl font-black tracking-tighter leading-none">PRESENCIA<br />REGIONAL.</h2>
                        </div>
                        <div className="flex items-center gap-3 border border-white/8 px-5 py-2.5 rounded-full">
                            <div className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] animate-pulse" />
                            <span className="text-white/30 text-[9px] font-black uppercase tracking-[0.5em]">7 sucursales en Córdoba</span>
                        </div>
                    </AnimatedSection>

                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6">
                        {sucursales.map((s, i) => (
                            <AnimatedSection key={s.nombre} delay={i * 0.07}>
                                <div className="group border-t border-white/8 pt-8 hover:border-[#c9a84c]/50 transition-all duration-500 cursor-default">
                                    <div className="flex items-center gap-2 mb-3">
                                        <MapPin size={9} className="text-[#c9a84c] opacity-0 group-hover:opacity-100 transition-all" />
                                        <span className="text-[8px] text-white/20 uppercase tracking-widest font-black group-hover:text-[#c9a84c]/50 transition-all">Sede</span>
                                    </div>
                                    <span className="text-base font-black group-hover:text-[#c9a84c] transition-colors duration-300 leading-tight block">{s.nombre}</span>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            {/* CTA */}
            <section className="py-40 px-6 md:px-16 bg-[#050f08] relative overflow-hidden">

                <AnimatedSection className="relative z-10 max-w-5xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-20 items-center">
                        {/* IZQUIERDA */}
                        <div>
                            <div className="text-[#c9a84c] text-[10px] font-black uppercase tracking-[0.6em] mb-6">Portal exclusivo</div>
                            <h2 className="text-4xl md:text-6xl font-black tracking-tighter mb-8 leading-none">
                                Tu campo,<br />
                                <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.3)', color: 'transparent' }}>siempre</span><br />
                                <span className="text-[#c9a84c]">conectado.</span>
                            </h2>
                            <p className="text-white/30 text-sm leading-relaxed mb-10 max-w-sm">
                                Diseñado para el productor moderno. Información clara, acceso simple y todo lo que necesitás en un solo lugar.
                            </p>
                            <a href="/login" className="group inline-flex items-center gap-3 bg-[#c9a84c] hover:bg-[#ddb94e] text-[#050f08] font-black uppercase tracking-widest text-[11px] px-10 py-5 rounded-full transition-all duration-300 no-underline">
                                Ingresar al portal
                                <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </a>
                        </div>

                        {/* DERECHA — features */}
                        <div className="flex flex-col gap-4">
                            {[
                                { n: "01", t: "Información en tiempo real", d: "Datos actualizados con cada sincronización desde nuestros sistemas." },
                                { n: "02", t: "Acceso desde cualquier dispositivo", d: "Celular, tablet o computadora. Tu portal siempre disponible." },
                                { n: "03", t: "Historial completo", d: "Cada operación registrada y disponible cuando la necesitás." },
                            ].map((f) => (
                                <div key={f.n} className="flex items-start gap-5 p-5 border border-white/5 rounded-2xl hover:border-[#c9a84c]/15 transition-all duration-500 group">
                                    <span className="text-[#c9a84c]/30 text-[11px] font-black tracking-widest mt-0.5 group-hover:text-[#c9a84c]/60 transition-colors">{f.n}</span>
                                    <div>
                                        <div className="text-white text-[12px] font-black uppercase tracking-wider mb-1">{f.t}</div>
                                        <div className="text-white/25 text-[11px] leading-relaxed">{f.d}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </AnimatedSection>
            </section>

            {/* FOOTER */}
            <footer className="bg-[#030a04] border-t border-white/5 px-6 md:px-16 py-16">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
                    <div className="flex items-center gap-4">
                        <img src="logo-integ.png" alt="Integral" className="w-8 h-8 object-contain opacity-60" />
                        <div>
                            <div className="text-white/60 font-black tracking-widest text-[12px] uppercase">Integral Agropecuaria S.R.L</div>
                            <div className="text-[#c9a84c]/40 text-[9px] tracking-[0.6em] uppercase font-bold mt-0.5">Conocernos rinde</div>
                        </div>
                    </div>

                    <div className="flex gap-8">
                        {["Nosotros", "Servicios", "Sucursales", "Productos"].map(item => (
                            <a key={item} href={`#${item.toLowerCase()}`} className="text-white/20 hover:text-white/50 text-[10px] uppercase tracking-widest font-bold no-underline transition-colors">{item}</a>
                        ))}
                    </div>

                    <div className="flex items-center gap-6">
                        <a href="https://www.facebook.com/integralagrop/?locale=es_LA" target="_blank" className="text-white/15 hover:text-[#c9a84c] transition-all duration-300 no-underline">
                            <Facebook size={18} strokeWidth={1.5} />
                        </a>
                        <a href="https://www.instagram.com/integralagropecuaria/" target="_blank" className="text-white/15 hover:text-[#c9a84c] transition-all duration-300 no-underline">
                            <Instagram size={18} strokeWidth={1.5} />
                        </a>
                    </div>
                </div>

                <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-white/15 text-[9px] tracking-[0.4em] uppercase font-bold">
                        © {new Date().getFullYear()} — Córdoba, Argentina
                    </p>
                    <p className="text-white/10 text-[9px] tracking-[0.4em] uppercase font-bold">
                        Excelencia Agropecuaria
                    </p>
                </div>
            </footer>
        </div>
    );
}